import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionServant } from './scheduled_section_servant';
import { ScheduledSectionStatusServant } from './scheduled_section_status_servant';
import { ScheduledSectionTileServant } from './scheduled_section_tile_servant';

export class RegisteredSectionServant {
  constructor(
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngScheduledSectionTileServant: ScheduledSectionTileServant
  ) {}

  canBeWithdrawn(section: ISection) {
    const canSectionBeWithdrawn =
      this.ngScheduledSectionStatusServant.canWithdraw(section) &&
      this.ngScheduledSectionServant.isSectionRegistered(section) &&
      this.ngScheduledSectionTileServant.isWithdrawEnabled();
    return canSectionBeWithdrawn;
  }

  canBeDropped(section: ISection): boolean {
    const canSectionBeSelectedForDrop =
      this.canBeWithdrawn(section) ||
      this.ngScheduledSectionStatusServant.isStatusWaitlisted(section) ||
      this.ngScheduledSectionStatusServant.isRegisteredOrInprogress(section);
    return canSectionBeSelectedForDrop;
  }
}

angular.module('capability-ng-scheduler').service('ngRegisteredSectionServant', RegisteredSectionServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/registered_section_servant.ts